import React from 'react';
import Layout from "../components/layout/layout";
import {useStaticQuery, graphql} from "gatsby";
import orderQuery from "../modules/orderDesigns";
import CallToAction from "../components/callToAction/callToAction";
import CategoryContainer from "../components/categoryContainer/categoryContainer";
import "../sass/pages/design.scss"
import ImageWrapper from "../components/imageWrapper/imageWrapper";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import Random from "another-random-package";

function Design() {
    const query = useStaticQuery(graphql`
    query Designs {
        contentfulDesignPortfolioOrder(title: {eq: "Design Portfolio Order "}) {
            order {
                slug
            }
        }
            allContentfulDesign {
                nodes {
                    mainImage {
                        file {
                            url
                        }
                    gatsbyImageData(formats: [AUTO, WEBP])
                }
                name
                slug
            }
        }
    }
  `);
    const orderedPages = orderQuery(query);
    return (
        <Layout
            name={"design"}
            current={"design"}
            keywords={"Staser, creative, design, Branding, print, packaging, lettering"}
        >
            <section>
                <CategoryContainer categories={["branding", "print", "packaging", "lettering"]}>
                    design
                </CategoryContainer>
                <div className="designs">
                    {
                        orderedPages.map(data=>{
                            const {mainImage: {gatsbyImageData}, name, slug,} = data;
                            let config = {
                                size: "huge",
                                link: `${ slug }`,
                                overlay: true,
                                name,
                            };
                            return (
                                <ImageWrapper key={Random.randomStringAlphaNumeric(12)} config={config}>
                                    <GatsbyImage
                                        alt={"some text"}
                                        image={getImage(gatsbyImageData)}
                                        style={{
                                            width:"100%",
                                            height:"100%",
                                        }}
                                    />
                                </ImageWrapper>)
                        })
                    }
                </div>
            </section>
            <CallToAction/>
        </Layout>
    );
}

export default Design;
